
class CapViewStudentStops {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_student_stops'
}

function create(config) {
  return new CapViewStudentStops(config)
}

export default {
  key,
  create,
}
